export default __webpack_public_path__ + "3c61f22e086154bb3f65ab0ee0c7716d.png";